import { render, staticRenderFns } from "./ShowKubeConfigDialog.vue?vue&type=template&id=a2987536"
import script from "./ShowKubeConfigDialog.vue?vue&type=script&lang=js"
export * from "./ShowKubeConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports